export default __webpack_public_path__ + "static/logo-bd2ea4599ec051c627de7f35d0e11a68.svg";